<template>
  <div class="button-container" :class="className">
    <button class="button-inner" v-bind="$attrs" v-on="$listeners"><slot /></button>
  </div>
</template>
<script>
export default {
  props: {
    type: {
      type: String,
      default: '',
    },
  },
  data: () => ({
  }),
  computed: {
    className() {
      return this.type ? `button-container-${this.type}` : ''
    }
  },
  inheritAttrs: false,
}
</script>
<style lang="less" scoped>
.button-container {
  width: 100%;
  height: 60px;
  &-border {
    height: 80px;
    background: url(~@/assets/result/button-border.svg) no-repeat;
    background-size: 100% 100%;
    padding: 8px 17px;
  }
  .button-inner {
    width: 100%;
    height: 60px;
    line-height: 60px;
    text-align: center;
    background: linear-gradient(180deg, #ffe799 0%, #fc4 100%);
    color: #823e0d;
    font-family: 'Alibaba-PuHuiTi';
    font-size: 24px;
    font-weight: 800;
    border-radius: 10px;
    border: none;
    cursor: pointer;
    &:hover {
      background: linear-gradient(0deg, rgba(255, 255, 255, 0.30) 0%, rgba(255, 255, 255, 0.30) 100%), linear-gradient(180deg, #FFE799 0%, #E3B63D 100%);
    }
  }
  
}
</style>